import React from 'react';
import { Link } from 'react-router-dom';
import {
  Box,
  Button,
  Container,
  Typography,
  Stack,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import {
  Login as LoginIcon,
  PersonAdd as PersonAddIcon,
  BarChart as BarChartIcon,
} from '@mui/icons-material';

export default function Landing() {
  return (
    <Box
      sx={(theme) => ({
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 50%, ${theme.palette.primary.light} 100%)`,
      })}
    >
      <Container maxWidth="md" sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', py: 6 }}>
        <Box sx={{ textAlign: 'center', mb: 6 }}>
          <BarChartIcon sx={{ fontSize: 64, color: 'white', mb: 2 }} />
          <Typography variant="h3" component="h1" fontWeight="bold" color="white" gutterBottom>
            SupaCRM
          </Typography>
          <Typography variant="h6" sx={{ color: (theme) => alpha(theme.palette.common.white, 0.9), maxWidth: 480, mx: 'auto', mb: 4 }}>
            Enterprise sales pipeline, deals, and customer management. Get started in minutes.
          </Typography>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={2}
            justifyContent="center"
            alignItems="center"
          >
            <Button
              component={Link}
              to="/login"
              variant="contained"
              size="large"
              startIcon={<LoginIcon />}
              sx={{
                bgcolor: 'white',
                color: 'primary.main',
                px: 4,
                py: 1.5,
                '&:hover': {
                  bgcolor: 'grey.100',
                },
              }}
            >
              Sign In
            </Button>
            <Button
              component={Link}
              to="/register"
              variant="outlined"
              size="large"
              startIcon={<PersonAddIcon />}
                sx={{
                  borderColor: 'white',
                  color: 'white',
                  px: 4,
                  py: 1.5,
                  '&:hover': {
                    borderColor: 'white',
                    bgcolor: (theme) => alpha(theme.palette.common.white, 0.1),
                  },
                }}
            >
              Sign Up
            </Button>
          </Stack>
        </Box>
        <Typography variant="body2" sx={{ color: (theme) => alpha(theme.palette.common.white, 0.7), textAlign: 'center' }}>
          Already have an account?{' '}
          <Box component={Link} to="/login" sx={{ color: 'white', textDecoration: 'underline', fontWeight: 600 }}>
            Sign in here
          </Box>
          {' • '}
          New user?{' '}
          <Box component={Link} to="/register" sx={{ color: 'white', textDecoration: 'underline', fontWeight: 600 }}>
            Create account
          </Box>
        </Typography>
      </Container>
    </Box>
  );
}
